import Checkbox from '../../inputs/Checkboxes/Checkbox/Checkbox';

import classes from './ListItems.module.scss';

const ListItems = ({ className, columns, items, showCheckbox, customColumns, onCheck }) => {
  const containerClasses = [classes.container, 'semibold-16'];
  className && containerClasses.push(className);

  const gridTemplateColumnsValues = `repeat(${showCheckbox ? columns.length + 1 : columns.length},max-content)`;

  const columnsItems = showCheckbox ? [{ key: 'isChecked' }].concat(columns) : columns;

  const lastColumnNumber = (showCheckbox ? columns.length + 1 : columns.length) - 1;

  const classColumnChecked = {
    0: classes['first-column-checked'],
    [lastColumnNumber]: classes['last-column-checked']
  };

  const classColumnNotCheked = {
    0: classes['first-column'],
    [lastColumnNumber]: classes['last-column']
  };

  const customColumnsItems = { ...customColumns };
  if (showCheckbox)
    customColumnsItems.isChecked = (item, index) => (
      <Checkbox key={`${index}-checbox`} checked={item.isChecked} onClick={checked => onCheck(index, checked)} />
    );

  return (
    <div className={containerClasses.join(' ')} style={{ gridTemplateColumns: gridTemplateColumnsValues }}>
      {columnsItems.map(({ key, label }) => (
        <div key={key} className={`semibold-16 ${classes.columns}`}>
          {label}
        </div>
      ))}
      {items
        .filter(item => item.show !== false)
        .map((item, index) => {
          return columnsItems.map(({ key }, idx) => (
            <div
              className={`${
                item.isChecked ? classColumnChecked[idx] || classes['column-checked'] : classColumnNotCheked[idx] || classes['column']
              } ${classes.value} medium-16 text-ellipsis`}
              // Corregido: Key única que combina index del item, idx de columna y key de campo
              // para evitar warnings de React sobre keys duplicadas en mapeos anidados
              key={`${index}-${idx}-${key}`}
              name={key}>
              {customColumnsItems?.[key] ? customColumnsItems[key](item, index) : item[key]}
            </div>
          ));
        })}
    </div>
  );
};

export default ListItems;
